import {CommonModule} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';

import {ApiService} from '../../services/api.service';

@Component({
    selector: 'app-sales-installation-partner-detail',
    imports: [CommonModule],
    templateUrl: './sales-installation-partner-detail.component.html',
    styleUrls: ['../../lead-management/lead-management.shared.css']
})
export class SalesInstallationPartnerDetailComponent implements OnInit {
  partner: any = null;
    reverting = false;

    constructor(
        private apiService: ApiService,
        private route: ActivatedRoute,
        public router: Router,
        private toastr: ToastrService,
    ) {
    }

    get canRevertToLead(): boolean {
        return !!(this.partner?.source_lead);
    }

  ngOnInit(): void {
    const id = Number(this.route.snapshot.paramMap.get('id'));
    this.apiService.getSalesInstallationPartner(id).subscribe({
      next: (response: any) => {
        this.partner = response;
      }
    });
  }

    revertToLead(): void {
        if (!this.partner?.id || this.reverting) {
            return;
        }
        this.reverting = true;
        this.apiService.revertSalesInstallationPartnerToLead(this.partner.id).subscribe({
            next: (response: any) => {
                this.reverting = false;
                this.toastr.success('Lead restored to the lead listing.', 'Success');
                if (response?.id) {
                    this.router.navigate(['lead-management/leads', response.id]);
                    return;
                }
                this.ngOnInit();
            },
            error: () => {
                this.reverting = false;
            },
        });
    }
}
